export default __webpack_public_path__ + "images/99b0f67a6b5dce475f88b61d9e9cbf0e.png";